import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../services/api';

const GOLD = '#B8892A';
const BD   = '#E8E0D0';
const RED  = '#8C1F1F';
const MUTED = '#6B5E4E';
const GREEN = '#2A6645';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState('');

  const inputStyle = {
    width: '100%', padding: '11px 14px', border: '1px solid ' + BD, borderRadius: 2,
    fontFamily: 'var(--sans)', fontSize: 13, color: '#110E0A',
    background: '#F8F5F0', outline: 'none', boxSizing: 'border-box',
  };

  const submit = async () => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError(t('auth.emailPlaceholder')); return;
    }
    setLoading(true); setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || t('common.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ fontFamily: 'var(--sans)', background: '#F8F5F0', minHeight: '100vh' }}>
      {/* Header */}
      <header style={{ background: '#fff', borderBottom: '1px solid ' + BD, padding: '0 24px', height: 56, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }} onClick={() => navigate('/')}>
          <div style={{ width: 32, height: 32, borderRadius: 4, background: '#8C1F1F', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#F5E6D0', fontSize: 10, fontWeight: 700, lineHeight: 1.1, textAlign: 'center', letterSpacing: 1 }}>云川<br/>中古</div>
          <span style={{ fontFamily: 'var(--serif)', fontSize: 17, color: GOLD, letterSpacing: 4 }}>云川中古</span>
        </div>
        <span onClick={() => navigate('/login')} style={{ fontSize: 12, color: GOLD, cursor: 'pointer' }}>{t('auth.backToLogin')}</span>
      </header>

      <div style={{ maxWidth: 420, margin: '60px auto', padding: '0 20px' }}>
        <div style={{ background: '#fff', border: '1px solid ' + BD, borderRadius: 4, overflow: 'hidden', boxShadow: '0 2px 12px rgba(26,18,8,.10)' }}>
          <div style={{ padding: '20px 28px 16px', borderBottom: `2px solid ${RED}`, background: 'linear-gradient(135deg,#F8F5F0,#fff)' }}>
            <div style={{ fontFamily: 'var(--mono)', fontSize: 8, letterSpacing: 3, color: RED, marginBottom: 6 }}>PASSWORD RESET</div>
            <div style={{ fontFamily: 'var(--serif)', fontSize: 20, fontWeight: 600, color: '#110E0A', letterSpacing: 2 }}>{t('forgotPassword.title')}</div>
            <div style={{ fontSize: 12, color: MUTED, marginTop: 4 }}>
              {t('forgotPassword.desc')}
            </div>
          </div>

          <div style={{ padding: 28 }}>
            {sent ? (
              <div style={{ textAlign: 'center', padding: '12px 0' }}>
                <div style={{ fontSize: 40, marginBottom: 16 }}>📬</div>
                <div style={{ fontSize: 15, fontWeight: 600, color: '#110E0A', marginBottom: 8 }}>{t('forgotPassword.sendSuccess')}</div>
                <div style={{ fontSize: 13, color: MUTED, lineHeight: 1.8, marginBottom: 20 }}>
                  重置链接已发送至 <strong>{email}</strong><br />
                  请在30分钟内点击邮件中的链接完成重置<br />
                  <span style={{ fontSize: 12, color: '#A8998A' }}>（注意检查垃圾邮件文件夹）</span>
                </div>
                <div style={{ padding: '10px 14px', background: 'rgba(140,31,31,0.06)', border: '1px solid rgba(140,31,31,0.18)', borderRadius: 2, fontSize: 12, color: RED, marginBottom: 20 }}>
                  🔒 重置链接点开后还需验证注册手机号收到的短信，请确保手机在身边
                </div>
                <button onClick={() => navigate('/login')} style={{ padding: '10px 28px', background: GOLD, border: 'none', borderRadius: 2, color: '#fff', fontSize: 13, cursor: 'pointer' }}>
                  {t('auth.backToLogin')}
                </button>
              </div>
            ) : (
              <>
                {error && (
                  <div style={{ padding: '10px 14px', borderRadius: 2, marginBottom: 16, background: 'rgba(140,31,31,0.07)', border: '1px solid rgba(140,31,31,0.2)', color: RED, fontSize: 12 }}>
                    ⚠ {error}
                  </div>
                )}
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 12, color: MUTED, marginBottom: 6 }}>{t('auth.email')} <span style={{ color: RED, fontSize: 10 }}>*</span></div>
                  <input
                    type="email" value={email}
                    onChange={e => { setEmail(e.target.value); setError(''); }}
                    onKeyDown={e => e.key === 'Enter' && submit()}
                    placeholder={t('auth.emailPlaceholder')}
                    style={inputStyle}
                  />
                </div>
                <div style={{ padding: '10px 14px', background: 'rgba(42,102,69,0.07)', border: '1px solid rgba(42,102,69,0.15)', borderRadius: 2, fontSize: 12, color: GREEN, marginBottom: 20 }}>
                  🔒 重置流程需同时验证邮箱链接 + 注册手机短信，请确保两者均可访问
                </div>
                <button
                  onClick={submit} disabled={loading || !email.trim()}
                  style={{
                    width: '100%', padding: 13, background: loading || !email.trim() ? '#C0A882' : RED,
                    border: 'none', borderRadius: 2, color: '#fff',
                    fontFamily: 'var(--sans)', fontSize: 14, cursor: loading || !email.trim() ? 'not-allowed' : 'pointer',
                  }}
                >
                  {loading ? t('common.loading') : t('auth.sendCode')}
                </button>
                <div style={{ textAlign: 'center', marginTop: 16, fontSize: 12, color: '#A8998A' }}>
                  {t('auth.hasAccount')}<span onClick={() => navigate('/login')} style={{ color: GOLD, cursor: 'pointer' }}>{t('auth.goLogin')}</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
